var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card__media media__video border-radius-zero",
      style: _vm.videoStyle
    },
    [
      _vm.video.isFeatured
        ? _c("div", { staticClass: "media__video__feature" }, [
            _vm._v(
              "\n    " + _vm._s(_vm.$t("video._sidebar.featured")) + "\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm.video.duration
        ? _c(
            "div",
            { staticClass: "media__video__duration  d-none d-sm-flex" },
            [
              _c("i", {
                staticClass: "material-icons",
                attrs: { "data-icon": "play_arrow" }
              }),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t("video._sidebar.duration", {
                      duration: _vm.video.duration
                    })
                  )
                )
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "media__video__play  d-none d-sm-flex" }, [
      _c("button", {
        staticClass: "vs-btn btn btn--play",
        attrs: { type: "button" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }